import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';
import './MissionPage.css';

function MissionPage({ onLoginClick }) {
  return (
    <Layout onLoginClick={onLoginClick}>
      <div className="mission-page">
        <section className="mission-hero">
          <div className="mission-hero-bg" />
          <div className="mission-hero-overlay" />
          <div className="mission-hero-content">
            <h1>Our Mission</h1>
            <p>Empowering farmers with reliable transport</p>
          </div>
        </section>

        <section className="mission-content">
          <div className="mission-content-inner">
            <h2>Empowering Farmers Through Transport</h2>
            <p>
              Our mission is to empower farmers with reliable, affordable, and accessible transport — 
              so that every harvest reaches the market, and every farmer can focus on what they do best: growing.
            </p>
            <p>
              We believe that transport should never stand between a farmer and their livelihood. Through 
              FarmFleet, we connect farmers with organized, tracked transport services that are simple 
              to use. No complex apps, no barriers. Request transport and we handle the rest.
            </p>
            <p>
              By making logistics transparent, predictable, and fair, we help farmers get their produce 
              to market on time — reducing waste, increasing income, and building stronger agricultural 
              supply chains for everyone.
            </p>
          </div>
        </section>

        <section className="mission-cta">
          <div className="mission-cta-inner">
            <h2>Learn More</h2>
            <p>Explore our story and get in touch.</p>
            <div className="mission-cta-buttons">
              <Link to="/about" className="btn-about">About Us</Link>
              <Link to="/contact" className="btn-contact">Contact Us</Link>
            </div>
          </div>
        </section>
      </div>
    </Layout>
  );
}

export default MissionPage;
